import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";

const base = () => `${PARKIT_API_BASE_URL}/parkit/v2/notifications`;
// Every call needs medium=WEB: parkit-server resolves a different user for the default SNS inbox.
const web = { medium: "WEB" };

export const getNotifications = (size) =>
  axiosApiInstance.get(base(), { params: { ...web, page: 0, size } });

export const getUnreadNotificationCount = () =>
  axiosApiInstance.get(`${base()}/unread-count`, { params: web });

export const markNotificationRead = (id) =>
  axiosApiInstance.patch(`${base()}/${id}`, { read: true }, { params: web });

export const markAllNotificationsRead = () =>
  axiosApiInstance.post(`${base()}/read-all`, null, { params: web });
